export const chartColumns = () => {
  return [
    {
      field: 'expenseCode',
      title: '费用名称',
      width: '120',
      editRender: { name: 'expenseCode' },
    },
    {
      field: 'commodityClassificationCode',
      title: '商品分类',
      width: '140',
      editRender: { name: 'commodityClassification' },
    },
    {
      field: 'commodityTypeCode', //
      title: '商品名称',
      width: '150',
      editRender: { name: 'commodityType' },
    },
    {
      field: 'commodityCategoryCode', //
      title: '商品子类',
      width: '140',
      editRender: { name: 'commodityCategory' },
    },
    {
      field: 'commoditySpecificationsId',
      title: '商品规格',
      width: '140',
      editRender: { name: 'commoditySpecificationsId' },
    },
    // {
    //   field: 'detailProductItems',
    //   title: '货物分类',
    //   width: '140',
    //   editRender: { name: 'commoditySpecifications' },
    // },
    {
      field: 'pricingStandard',
      title: '计价标准',
      width: '140',
      editRender: { name: 'pricingStandard' },
    },
    {
      field: 'pricingUnit',
      title: '计价单位',
      width: '140',
      editRender: { name: 'pricingUnit' },
    },
    {
      field: 'unitPrice',
      title: '单价/元',
      width: '140',
      editRender: { name: 'unitPrice' },
    },
    {
      field: 'lowerTimeLimit',
      title: '时间下限',
      width: '140',
      editRender: { name: 'lowerTimeLimit' },
    },
    {
      field: 'upperTimeLimit',
      title: '时间上限',
      width: '140',
      editRender: { name: 'upperTimeLimit' },
    },
    {
      field: 'lowerWeightLimit',
      title: '重量下限',
      width: '140',
      editRender: { name: 'lowerWeightLimit' },
    },
    {
      field: 'upperWeightLimit',
      title: '重量上限',
      width: '140',
      editRender: { name: 'upperWeightLimit' },
    },
    {
      field: 'packingId',
      title: '包装',
      width: '140',
      editRender: {
        name: 'packingId',
      },
    },
    {
      field: 'packageCategoryName', //
      title: '包装类别',
      width: '140',
      editRender: { name: 'packageCategoryName' },
    },
    {
      field: 'minimumAmount',
      title: '保底量',
      width: '140',
      editRender: { name: 'minimumAmount' },
    },
    {
      field: 'isSpecialLibrary',
      title: '是否专库',
      width: '140',
      editRender: { name: 'isSpecialLibrary' },
    },
    {
      field: 'reservoirAreaName',
      title: '库区名称',
      width: '140',
      editRender: { name: 'reservoirAreaName' },
    },
    {
      field: 'reservoirType',
      title: '库区类型',
      width: '140',
      editRender: { name: 'reservoirType' },
    },
    {
      field: 'remarks',
      title: '备注',
      width: '140',
      editRender: {
        name: 'input',
        type: 'default',
      },
    },
  ];
};
